import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import Button from 'flow/components/ui-components/Button';
import Tooltip from 'flow/components/ui-components/Tooltip';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { selectOriginDTOSubtype } from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';

interface Props {
    ticketKey: TicketKey;
}

const SummaryButton = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { openModal } = useModal();
    const dtoSubtype = useAppSelector((state) =>
        selectOriginDTOSubtype(state, ticketKey),
    );

    const onClick = () => {
        openModal('ticketSummary', {
            summaryContext: 'ALL',
            ticketKey,
        });

        dispatch(
            segmentTrack(TICKET_STRINGS.OPEN_GENERATE_SUMMARY_MODAL_CLICK, {
                component: `Ticket footer ${dtoSubtype}`,
            }),
        );
    };

    return (
        <Tooltip label={i18next.t('ai.summary.generate')}>
            <Button
                onClick={onClick}
                iconKey="summarize"
                className="rounded-sm bg-gray-200 hover:bg-gray-300"
            />
        </Tooltip>
    );
};

export default SummaryButton;
